"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryPcbRuleSet = exports.arbitraryModelNodeWithModelAsset = exports.arbitraryUniquePcbVirtualNodes = exports.arbitraryUniquePcbBakedNodes = exports.arbitraryUniquePcbNodes = exports.arbitraryPcbVirtualNode = exports.arbitraryPcbBakedNode = exports.arbitraryPcbNode = exports.arbitraryPcbNodeType = void 0;
const tslib_1 = require("tslib");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
const structure_1 = require("../../src/pcb/node/structure");
const document_1 = require("./document");
exports.arbitraryPcbNodeType = fast_check_1.default.constantFrom(structure_1.PcbNodeTypes.layout, structure_1.PcbNodeTypes.element, structure_1.PcbNodeTypes.via, structure_1.PcbNodeTypes.routeSegment, structure_1.PcbNodeTypes.pad, structure_1.PcbNodeTypes.footprint, structure_1.PcbNodeTypes.model, structure_1.PcbNodeTypes.container, structure_1.PcbNodeTypes.group, structure_1.PcbNodeTypes.text, structure_1.PcbNodeTypes.line, structure_1.PcbNodeTypes.circle, structure_1.PcbNodeTypes.rectangle, structure_1.PcbNodeTypes.net, structure_1.PcbNodeTypes.fill, structure_1.PcbNodeTypes.zone);
/**
 * Create an arbitrary Pcb node.
 */
const arbitraryPcbNode = (constraints = {}) => 
// TODO: why need to cast any here, AnyPcbNode is not compatible
// with this arbitrary setup any more after introducing distributive
// conditional types??
fast_check_1.default.record({
    type: constraints.type ? fast_check_1.default.constant(constraints.type) : exports.arbitraryPcbNodeType,
    name: constraints.name ? fast_check_1.default.constant(constraints.name) : fast_check_1.default.string(),
    uid: constraints.uid ? fast_check_1.default.constant(constraints.uid) : fast_check_1.default.uuid(),
    pcbNodeRuleSet: fast_check_1.default.constantFrom({}),
    parentUid: constraints.parentUid ? fast_check_1.default.constant(constraints.parentUid) : fast_check_1.default.uuid(),
    childUids: constraints.childUids ? fast_check_1.default.constant(constraints.childUids) : fast_check_1.default.array(fast_check_1.default.uuid(), { maxLength: 0 }),
});
exports.arbitraryPcbNode = arbitraryPcbNode;
/**
 * Create an arbitrary Pcb baked node.
 *
 * TODO: Right now we simply claim that the arbitrary pcb baked node
 * has a `bakedRules` field and a `flattenedRules` field, to distinguish
 * it with `arbitraryPcbNode` above. Later, we should provide good ways
 * to mock those fields if possible
 */
const arbitraryPcbBakedNode = (constraints = {}) => 
// TODO: why need to cast any here, AnyPcbBakedNode is not compatible
// with this arbitrary setup any more after introducing distributive
// conditional types??
fast_check_1.default.record({
    type: constraints.type ? fast_check_1.default.constant(constraints.type) : exports.arbitraryPcbNodeType,
    name: constraints.name ? fast_check_1.default.constant(constraints.name) : fast_check_1.default.string(),
    uid: constraints.uid ? fast_check_1.default.constant(constraints.uid) : fast_check_1.default.uuid(),
    pcbNodeRuleSet: fast_check_1.default.constantFrom({}),
    parentUid: constraints.parentUid ? fast_check_1.default.constant(constraints.parentUid) : fast_check_1.default.uuid(),
    childUids: constraints.childUids ? fast_check_1.default.constant(constraints.childUids) : fast_check_1.default.array(fast_check_1.default.uuid(), { maxLength: 0 }),
    bakedRules: fast_check_1.default.constant({}),
    flattenedRules: fast_check_1.default.constant({}),
});
exports.arbitraryPcbBakedNode = arbitraryPcbBakedNode;
const arbitraryPcbVirtualNode = (constraints = {}) => 
// TODO: why need to cast any here, AnyPcbVirtualNode is not compatible
// with this arbitrary setup any more after introducing distributive
// conditional types??
fast_check_1.default.record({
    type: constraints.type ? fast_check_1.default.constant(constraints.type) : exports.arbitraryPcbNodeType,
    name: constraints.name ? fast_check_1.default.constant(constraints.name) : fast_check_1.default.string(),
    uid: constraints.uid ? fast_check_1.default.constant(constraints.uid) : fast_check_1.default.uuid(),
    pcbNodeRuleSet: fast_check_1.default.constantFrom({}),
    parentUid: constraints.parentUid ? fast_check_1.default.constant(constraints.parentUid) : fast_check_1.default.uuid(),
    childUids: constraints.childUids ? fast_check_1.default.constant(constraints.childUids) : fast_check_1.default.array(fast_check_1.default.uuid(), { maxLength: 0 }),
    bakedRules: fast_check_1.default.constant({}),
    flattenedRules: fast_check_1.default.constant({}),
    virtualNodeInfo: fast_check_1.default.constant({}),
});
exports.arbitraryPcbVirtualNode = arbitraryPcbVirtualNode;
/**
 * Generate an array of arbitrary pcb nodes, and guarantee that each node
 * is unique (i.e. has unique uid)
 */
const arbitraryUniquePcbNodes = (constraints = {}) => fast_check_1.default.uniqueArray((0, exports.arbitraryPcbNode)(), {
    comparator: (nodeA, nodeB) => nodeA.uid === nodeB.uid,
    ...constraints,
});
exports.arbitraryUniquePcbNodes = arbitraryUniquePcbNodes;
/**
 * Generate an array of arbitrary pcb baked nodes, and guarantee that each node
 * is unique (i.e. has unique uid)
 */
const arbitraryUniquePcbBakedNodes = (constraints = {}) => fast_check_1.default.uniqueArray((0, exports.arbitraryPcbBakedNode)(), {
    comparator: (nodeA, nodeB) => nodeA.uid === nodeB.uid,
    ...constraints,
});
exports.arbitraryUniquePcbBakedNodes = arbitraryUniquePcbBakedNodes;
/**
 * Generate an array of arbitrary pcb virtual nodes, and guarantee that each node
 * is unique (i.e. has unique uid)
 */
const arbitraryUniquePcbVirtualNodes = (constraints = {}) => fast_check_1.default.uniqueArray((0, exports.arbitraryPcbVirtualNode)(), {
    comparator: (nodeA, nodeB) => nodeA.uid === nodeB.uid,
    ...constraints,
});
exports.arbitraryUniquePcbVirtualNodes = arbitraryUniquePcbVirtualNodes;
/**
 * Generate an arbitrary model node from an asset.
 */
exports.arbitraryModelNodeWithModelAsset = document_1.arbitraryModelAsset.chain((modelAsset) => fast_check_1.default.tuple(fast_check_1.default.record({
    type: fast_check_1.default.constantFrom(structure_1.PcbNodeTypes.model),
    name: fast_check_1.default.string(),
    uid: fast_check_1.default.uuid(),
    pcbNodeRuleSet: fast_check_1.default.record({
        asset: fast_check_1.default.record({
            uid: fast_check_1.default.uuid(),
            key: fast_check_1.default.constantFrom("asset"),
            value: fast_check_1.default.string(),
            payloadFileName: fast_check_1.default.constantFrom(modelAsset.storageName),
            disabled: fast_check_1.default.boolean(),
        }),
    }),
    // TODO: This is a constant that's defined by the tree traveler.  Shouldn't shadow it here.
    parentUid: fast_check_1.default.constantFrom(structure_1.pcbLayoutRootNodeId),
    childUids: fast_check_1.default.constant([]),
}), fast_check_1.default.constantFrom(modelAsset)));
const arbitraryPcbRuleSet = (constraints = {}) => {
    return fast_check_1.default.record({
        name: constraints.name ? fast_check_1.default.constant(constraints.name) : fast_check_1.default.string(),
        description: constraints.description ? fast_check_1.default.constant(constraints.description) : fast_check_1.default.string(),
        disabled: constraints.disabled ? fast_check_1.default.constant(constraints.disabled) : fast_check_1.default.boolean(),
        selector: constraints.selector ? fast_check_1.default.constant(constraints.selector) : fast_check_1.default.string(),
        rules: constraints.rules ? fast_check_1.default.constant(constraints.rules) : fast_check_1.default.object(),
    });
};
exports.arbitraryPcbRuleSet = arbitraryPcbRuleSet;
//# sourceMappingURL=pcb.js.map